import { useState } from 'react'

import MainContent from 'features/unifiedFlow/components/MainContent'

import { VariantLanguageContextProvider } from './context/VariantLanguageContext'
import useElementState from './hooks/useElementState'
import CenterSection from './centerSection'
import LeftSection from './leftSection'
import RightSection from './rightSection'

const Review = () => {
  const [selectedPersonalizationId, setSelectedPersonalizationId] =
    useState<string | undefined>()
  useElementState()

  return (
    <VariantLanguageContextProvider>
      <MainContent className="flex-wrap" id="main-content-page">
        <LeftSection
          onSelectPersonalization={setSelectedPersonalizationId}
          selectedPersonalizationId={selectedPersonalizationId}
        />
        <div className="relative flex flex-1">
          <CenterSection
            selectedPersonalizationId={selectedPersonalizationId}
            onSelectPersonalization={setSelectedPersonalizationId}
          />
          <RightSection />
        </div>
      </MainContent>
    </VariantLanguageContextProvider>
  )
}

export default Review
